import type { Block, BlockCreate, BlockCreateInput } from '@/types/blocks'
import { toArticleCreate } from './articleBlock'

export function toBlockCreate(block: Block, order: number): BlockCreate
export function toBlockCreate(block: Block): BlockCreateInput
export function toBlockCreate(block: Block, order?: number): BlockCreateInput {
  const { id: _id, createdAt: _c, updatedAt: _u, order: _o, originId: _oi, ...rest } = block
  // У статьи тело собирает toArticleCreate: он снимает и серверную мету, и поля,
  // которых нет в ArticleBlockCreate (включая order — тот возвращаем ниже общим путём).
  const base = block.type === 'article' ? toArticleCreate(block) : rest
  return (order === undefined ? base : { ...base, order }) as BlockCreateInput
}
